import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { Header } from './components/Header';
import { ListTable } from './components/ListTable';
import { Modals } from './components/Modals';
import { FilterContextProvider } from './contexts/FilterContextProvider';
import { ModalContextProvider } from './contexts/ModalContextProvider';
import { QueryContextProvider } from './contexts/QueryContextProvider';

export const ListIndexPage = () => (
  <SortingContextProvider>
    <PaginationContextProvider>
      <FilterContextProvider>
        <QueryContextProvider>
          <ModalContextProvider>
            <Header />
            <ListTable />
            <Modals />
          </ModalContextProvider>
        </QueryContextProvider>
      </FilterContextProvider>
    </PaginationContextProvider>
  </SortingContextProvider>
);
